import type { PropsWithChildren } from "react"
import React from "react"
import {
    Box,
    componentStyles,
    useTheme,
} from "@mallardbay/lib-react-components"

export default function NotificationCard({ children }: PropsWithChildren) {
    const styles = useStyleProps()

    return <Box style={styles.root}>{children}</Box>
}

function useStyleProps() {
    const { colors } = useTheme()
    return componentStyles({
        root: {
            width: "auto",
            marginLeft: 0,
            marginRight: 0,
            padding: "20px",
            borderRadius: "12px",
            backgroundColor: colors.cardBackgroundColor,
        },
    })
}
